import * as React from "react";
import { Grid, TextField } from "@mui/material";

export default function TenantUpdateForm({ tenantEditData, handleChangeTenantEditData }) {
	return (
		<Grid container component="form" noValidate autoComplete="off" spacing={2}>
			<Grid item xs={12} sm={6}>
				<TextField
					size="small"
					fullWidth
					label="First Name"
					name="first_name"
					value={tenantEditData.first_name}
					onChange={handleChangeTenantEditData}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<TextField
					size="small"
					fullWidth
					label="Last Name"
					name="last_name"
					value={tenantEditData.last_name}
					onChange={handleChangeTenantEditData}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<TextField
					size="small"
					fullWidth
					label="Username"
					name="username"
					value={tenantEditData.username}
					onChange={handleChangeTenantEditData}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<TextField
					size="small"
					fullWidth
					label="Email"
					type="email"
					name="email"
					value={tenantEditData.email}
					onChange={handleChangeTenantEditData}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<TextField
					size="small"
					fullWidth
					label="Phone Number"
					name="phone_number"
					value={tenantEditData.phone_number}
					onChange={handleChangeTenantEditData}
				/>
			</Grid>
		</Grid>
	);
}
